import { render, staticRenderFns } from "./teamBuilding.vue?vue&type=template&id=824934c8&scoped=true"
import script from "./teamBuilding.vue?vue&type=script&lang=js"
export * from "./teamBuilding.vue?vue&type=script&lang=js"
import style0 from "./teamBuilding.vue?vue&type=style&index=0&id=824934c8&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824934c8",
  null
  
)

export default component.exports